// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"79921129","68":"79921129","276":"006bbe42","501":"79921129","541":"79921129","575":"79921129","688":"559ebdee","766":"83b92b18","882":"3b4c7e99","971":"79921129","981":"3d6408f7"}[chunkId] + ".chunk.css";
};